import product1 from "../../images/product-1.jpg";
import product2 from "../../images/product-2.jpg";
import product3 from "../../images/product-3.jpg";
import dessert1 from "../../images/dessert1.jpg";
import dessert2 from "../../images/dessert2.jpg";
import dessert3 from "../../images/dessert3.jpg";

export const productData = [
  {
    index: 1,
    img: product1,
    alt: "pizza",
    name: "Supreme Pizza",
    desc: "Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto.",
    price: "$19.99",
    button: "Add to Cart",
  },
  {
    index: 2,
    img: product2,
    alt: "pizza",
    name: "Hawaiian Paradise",
    desc: "Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto.",
    price: "$16.99",
    button: "Add to Cart",
  },
  {
    index: 3,
    img: product3,
    alt: "pizza",
    name: "Veggie Overload",
    desc: "Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto.",
    price: "$14.99",
    button: "Add to Cart",
  }
]

export const productData2 = [
  {
    index: 1,
    img: dessert1,
    alt: "donuts",
    name: "Donuts",
    desc: "Moist cake ring with your choice of frosting and toppings.",
    price: "$2.99",
    button: "Add to Cart",
  },
  {
    index: 2,
    img: dessert2,
    alt: "ice cream",
    name: "Ice, Ice, Brownie",
    desc: "Your choice of ice cream flavor topped with chocolate and caramel syrup on our famous brownie.",
    price: "$8.99",
    button: "Add to Cart",
  },
  {
    index: 3,
    img: dessert3,
    alt: "cookies",
    name: "Chocolate Chunk Cookie",
    desc: "Chunky chocolately goodness.",
    price: "$2.99",
    button: "Add to Cart",
  }
]

